module.exports = __webpack_public_path__ + "img/sim_card.1c2c0273.svg";